import $http from "../../axios";
import {
    Notification,
    MessageBox
} from 'element-ui';

export async function getAccounts({ state, commit }) {
    let params = {
        notAux:false,
        onlyAux:true,
        paginate:false,
        bank_only:false,
        only_manage_balance:true
    }
    await $http
        .get("/api/cuentas",{params}).then(response => {
            commit("setAccounts", response.data.data);
        })
        .catch(error => {

        });
}
export async function getAccountsVoucher({ state, commit }) {
    let params = {
        notAux:false,
        onlyAux:true,
        paginate:false
    }
    await $http
        .get("/api/cuentas",{params}).then(response => {
            commit("setAccountsVoucher", response.data.data);
        })
        .catch(error => {

        });
}
export async function searchchconsecutive({commit, state}, data) {
    await $http.get('/api/tipos-de-comprobantes/'+data.voucherType_id, {params:data})
        .then((response) => {
            commit('setConsecutive', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
}
export async function createVouchers({commit , state}){
    state.loading_modal = true

    await $http.post('/api/comprobantes-varios', state.payload)
        .then((response)=>{
            state.loading_modal = false
            state.payload.document_id = response.data.data.document.id
            commit('updateVoucherPayload', response.data.data)

            /*ommit('setConsignedData', {
                document_payment_id: state.payload.document_transaction.document_payment_id,
                document_transaction_id: response.data.data.id,
                observation: state.payload.document_transaction.observation,
            })*/
        })
        .catch((error)=>{
            state.loading.module = false
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}
export async function finalizeAccountingDocument({commit , state, dispatch}){
    state.loading_modal = true
    state.payload.pending_consigned = state.pending_consigned
    await $http.post('/api/finalizar-documento-contable', state.payload)
        .then((response)=>{
            state.loading_modal = false
            commit('setFinalizeVoucher', response.data.data)
        })
        .catch((error)=>{
            state.loading.module = false
            let data = error.response.data
            Notification.error({
                title: "Error!",
                message: data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        })
}
export async function fetchContacts({ commit, state, rootState }) {
    let params = { params: state.params_contacts};
    await $http
        .get("/api/terceros", params)
        .then(response => {
            commit("setContacts", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function fetchReport({ commit, state }) {
    let params = { params: state.params};
    state.loading.module = true
    await $http.get("/api/get-balance-reconciliation", params).then(response => {
        console.log(response.data)
        commit("setReportData", response.data);
        state.loading.module = false
        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/balance_reconciliation/actions.js